export default "__VITE_ASSET__f25bd1e9__"